import { forwardRef, ReactNode } from 'react';
import { classNames } from '../../../../utils';

interface ImageCardProps {
  id: string;
  image: ReactNode;
  onClick: (id: string) => void;
  children: ReactNode;
  className?: string;
  imageClassName?: string;
  isApplyDefaulImageClassname?: boolean;
}

const ImageCard = forwardRef<HTMLDivElement, ImageCardProps>(
  (
    {
      image,
      id,
      onClick,
      children,
      className,
      isApplyDefaulImageClassname = true,
      imageClassName = '',
    }: ImageCardProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const onItemSelect = () => {
      if (onClick) {
        onClick(id);
      }
    };
    // ? ' relative w-[128px] h-[128px] top-[calc(50%-64px)] overflow-hidden left-[calc(50%-64px)] flex justify-center items-center'
    const defaultImageClassname = isApplyDefaulImageClassname
      ? ' relative  overflow-hidden flex justify-center items-center'
      : '';
    return (
      <div
        ref={ref}
        onClick={onItemSelect}
        key={id}
        className={classNames(
          `flex cursor-pointer flex-col h-[365px] relative overflow-hidden p-4 space-y-4 items-start bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-2xl shadow-sm hover:shadow-md dark:shadow-slate-900/30 dark:hover:shadow-slate-900/50 transition-all duration-200`,
          className || '',
        )}
      >
        <div className="relative bg-gradient-to-br from-gray-100 to-gray-50 dark:from-slate-700 dark:to-slate-700/50 h-[164px] max-h-[142.33px] border-none self-stretch flex rounded-xl overflow-hidden">
          <div className={classNames(defaultImageClassname, imageClassName)}>{image}</div>
        </div>
        {children}
      </div>
    );
  },
);

export default ImageCard;
